var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import SubTitles from 'xgplayer-subtitles';
import { Util, POSITIONS } from '../../plugin';
import OptionsIcon from '../common/optionsIcon';

var DEFAULT_CLOSE_TYPE = 'text-close';

function formartList(list) {
  var defaultIndex = -1;
  list.map(function (item, index) {
    if (!item.id && !item.language) {
      item.id = index;
    }
    !item.url && (item.url = item.src);
    !item.text && (item.text = item.label);
    !item.language && (item.language = item.srclang);
    item.isDefault === undefined && (item.isDefault = item.default);
    if (item.isDefault || item.default) {
      defaultIndex = index;
    }
  });
  return defaultIndex;
}

var TextTrack = function (_OptionsIcon) {
  _inherits(TextTrack, _OptionsIcon);

  _createClass(TextTrack, null, [{
    key: 'pluginName',
    get: function get() {
      return 'texttrack';
    }
    // 默认配置信息

  }, {
    key: 'defaultConfig',
    get: function get() {
      return {
        position: POSITIONS.CONTROLS_RIGHT,
        index: 6,
        list: [],
        isDefaultOpen: true,
        style: {
          follow: true, // 是否跟随控制栏调整位置
          mode: 'stroke', // 字体显示模式，默认是描边
          followBottom: 50, // 跟随底部控制栏的高度
          fitVideo: true, // 是否跟随视频自动调整字号
          offsetBottom: 2, // 字幕距离画面底部百分比，默认2%
          baseSizeX: 49, // 横屏视频适配基准字号
          baseSizeY: 28, // 竖屏视频适配基准字号
          minSize: 16, // pc端最小字号
          minMobileSize: 13, // 移动端最小字号
          line: 'double', // 最大显示行数 single/double/three
          fontColor: '#fff' // 字体颜色
        },
        closeText: { text: '不开启', iconText: '字幕' },
        className: 'xgplayer-texttrack',
        hidePortrait: false
      };
    }
  }]);

  function TextTrack(args) {
    _classCallCheck(this, TextTrack);

    var _this = _possibleConstructorReturn(this, (TextTrack.__proto__ || Object.getPrototypeOf(TextTrack)).call(this, args));

    _this.curRate = 1;
    return _this;
  }

  _createClass(TextTrack, [{
    key: 'beforeCreate',
    value: function beforeCreate(args) {
      var texttrack = args.player.config.texttrack || args.player.config.textTrack;
      if (Util.typeOf(texttrack) === 'Array') {
        args.config.list = texttrack;
      }
    }
  }, {
    key: 'afterCreate',
    value: function afterCreate() {
      var _config = this.config,
          list = _config.list,
          style = _config.style,
          isDefaultOpen = _config.isDefaultOpen;

      if (!list || list.length < 1) {
        return;
      }
      var defaultIndex = formartList(list);
      // 如果配置信息为默认开启，但是没有默认开启的语言，则默认第一个
      if (isDefaultOpen && defaultIndex < 0) {
        list[0].isDefault = true;
      }

      _get(TextTrack.prototype.__proto__ || Object.getPrototypeOf(TextTrack.prototype), 'afterCreate', this).call(this);

      var config = {
        subTitles: list,
        defaultOpen: isDefaultOpen
      };
      Object.keys(style).map(function (key) {
        config[key] = style[key];
      });
      this.subTitles = new SubTitles(config);
      this.subTitles.attachPlayer(this.player);
    }
  }, {
    key: 'show',
    value: function show() {
      if (!this.config.list || this.config.list.length === 0) {
        return;
      }
      _get(TextTrack.prototype.__proto__ || Object.getPrototypeOf(TextTrack.prototype), 'show', this).call(this);
    }

    // 更新字幕信息

  }, {
    key: 'updateSubtitles',
    value: function updateSubtitles() {
      var _this2 = this;

      var list = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var isDefaultOpen = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      var defaultIndex = formartList(list);
      var curLanguage = this.subTitles && this.subTitles.currentText ? this.subTitles.currentText.language : null;
      var cuIndex = null;
      list.map(function (item, index) {
        if (item.language === curLanguage) {
          item.isDefault = true;
          cuIndex = index;
        }
      });
      if (defaultIndex > -1 && defaultIndex !== cuIndex) {
        list[defaultIndex].isDefault = false;
      }
      this.subTitles.destroy();
      var config = {
        subTitles: list,
        defaultOpen: isDefaultOpen
      };
      Object.keys(this.config.style).map(function (key) {
        config[key] = _this2.config.style[key];
      });
      this.subTitles = new SubTitles(config);
      this.subTitles.attachPlayer(this.player);
      this.renderItemList();
    }
  }, {
    key: 'onItemClick',
    value: function onItemClick(e, data) {
      _get(TextTrack.prototype.__proto__ || Object.getPrototypeOf(TextTrack.prototype), 'onItemClick', this).apply(this, arguments);
      var target = e.delegateTarget;
      var language = target.getAttribute('language');
      var id = target.getAttribute('data-id');
      var type = target.getAttribute('data-type');
      if (this.subTitles) {
        if (type === DEFAULT_CLOSE_TYPE) {
          this.subTitles.switchOff();
        } else {
          this.subTitles.switch({ language: language, id: id }).catch(function (error) {
            console.log('onItemClick', error);
          });
        }
      }
    }
  }, {
    key: 'changeCurrentText',
    value: function changeCurrentText() {
      var _config2 = this.config,
          list = _config2.list,
          closeText = _config2.closeText;

      var index = this.curIndex;
      if (index - 1 < 0) {
        this.find('.icon-text').innerHTML = this.getTextByLang(closeText, 'iconText');
      } else if (index - 1 < list.length) {
        var curItem = list[index - 1];
        if (!curItem) return;
        this.find('.icon-text').innerHTML = this.getTextByLang(curItem, 'iconText');
      }
    }
  }, {
    key: 'renderItemList',
    value: function renderItemList() {
      var _this3 = this;

      var _config3 = this.config,
          list = _config3.list,
          closeText = _config3.closeText;

      var curIndex = 0;
      var items = [];
      items.push({
        showText: this.getTextByLang(closeText),
        'data-type': DEFAULT_CLOSE_TYPE
      });
      list.map(function (item, index) {
        var itemInfo = {
          language: item.language || item.srclang,
          'data-id': item.id
        };
        if (item.default || item.isDefault) {
          itemInfo.isCurrent = true;
          curIndex = index + 1;
        }
        itemInfo.showText = _this3.getTextByLang(item);
        items.push(itemInfo);
      });
      _get(TextTrack.prototype.__proto__ || Object.getPrototypeOf(TextTrack.prototype), 'renderItemList', this).call(this, items, curIndex);
    }
  }, {
    key: 'destroy',
    value: function destroy() {
      if (this.subTitles) {
        this.subTitles.destroy();
        this.subTitles = null;
      }
      _get(TextTrack.prototype.__proto__ || Object.getPrototypeOf(TextTrack.prototype), 'destroy', this).call(this);
    }
  }]);

  return TextTrack;
}(OptionsIcon);

export default TextTrack;